import { React, useCallback, useEffect, useState } from 'react';
import { useTranslation } from "react-i18next";
import "./index.scss";

import successTick from "../../../../assets/images/common/Success.gif";
import failed from "../../../../assets/images/common/failed.gif";

import Button from "../../../ui/Button";
import DropDown from '../../../ui/DropDown';

import { useSelector, useDispatch } from 'react-redux';
import { assignAndUnAssign } from '../../../../store/actions/organizationActions';
import { getCustomersList, resetCustomersList } from "../../../../store/actions/customerAction.js";
import { customersListForMonitors } from '../../../../store/actions/monitorAction';

import apiEndpoints from "../../../../apiEndpoints.js";

const ModifyMonitorModal = ({monitorDetails, clsoeModifyModal}) => {

    const customerListResponse = useSelector((state) => state?.customer?.customersListResponse);
    const assignedCustomersListForMonitorsResponse = useSelector((state) => state?.monitor?.assignedCustomersListForMonitorsResponse)
    const assignUnAssignResponse = useSelector((state) => state.organization?.assignUnAssignResponse)

    const { t } = useTranslation();

    const dispatch = useDispatch();

    const [activeTab, setActiveTab] = useState("assign");

    const [responseStatus, setResponseStatus] = useState(false);

    const [customerList, setCustomersList] = useState([]);
    const [customerSearchValue, setCustomerSearchValue] = useState("");
    const [customerSearchLoading, setCustomerSearchLoading] = useState("");
    const [customerCurrentPage, setCustomerCurrentPage] = useState(1);
    const [customerPageLoading, setCustomerPageLoading] = useState(false);
    const [customerTotalPage, setCustomerTotalPage] = useState(0);

    const [assignedCustomersList, setAssignedCustomersList] = useState([]);
    const [assignedCustomerSearch, setAssignedCustomerSearch] = useState("");
    const [assignedCustomerSearchLoading, setAssignedCustomerSearchLoading] = useState(false);
    const [assignedCustomerCurrentPage, setAssignedCustomerCurrentPage] = useState(1);
    const [assignedCustomerPageLoading, setAssignedCustomerPageLoading] = useState(false);
    const [assignedCustomerTotalPage, setAssignedCustomerTotalPage] = useState(0);

    const [selectedCustomer, setSelectedCustomer] = useState([]);
    const [isLoading, setIsLoading] = useState(false);

    const goBack = () => {
        setResponseStatus(false)
        setIsLoading(false)
        clsoeModifyModal()
    }

    const handleSelectCustomer = (value) => {
        setSelectedCustomer(value)
    }

    const changeTab = (value) => {
        setSelectedCustomer([])
        setActiveTab(value)
    }

    const fetchCustomerList = useCallback(()=>{        
        const baseUrl = `&page=${customerCurrentPage}&page_size=10`;
        const queryParams = customerSearchValue ? `&query=${customerSearchValue}` : "";
        const url = `${baseUrl}${queryParams}`
        dispatch(getCustomersList(url))
    },[dispatch, customerSearchValue, customerCurrentPage])

    const fetchAssignedCustomersList = useCallback(()=>{
        setAssignedCustomerSearchLoading(true)
        const baseUrl = `&monitor_id=${monitorDetails?.monitor_id}&page=${assignedCustomerCurrentPage}&page_size=10`;
        const queryParams = assignedCustomerSearch ? `&query=${assignedCustomerSearch}`: "";
        const url = `${baseUrl}${queryParams}`
        dispatch(customersListForMonitors(url, "modify"))
    },[dispatch, monitorDetails, assignedCustomerSearch, assignedCustomerCurrentPage])

    const saveList = () => {
        const ids = selectedCustomer.map(data => data.id);
        const isAssign = activeTab === "assign";
        
        const obj = {
            monitor_id: monitorDetails?.monitor_id,
            customer_ids: ids
        };
    
        const url = isAssign ? apiEndpoints.monitor.assignCustomerToMonitor() : apiEndpoints.monitor.unAssignCustomerToMonitor()
        setIsLoading(true)
        dispatch(assignAndUnAssign(url, obj));
    };

    useEffect(()=>{
        fetchCustomerList()
    },[fetchCustomerList, customerSearchValue])

    useEffect(()=>{
        fetchAssignedCustomersList()
    },[fetchAssignedCustomersList, assignedCustomerSearch])

    useEffect(()=>{
        if(customerListResponse != null) {
            setCustomerSearchLoading(false)
            setCustomerPageLoading(false)
            let newList = customerListResponse?.results.map((data)=>{
                return {
                    id: data.customer_id,
                    name: data.name,
                    value: data.customer_id,
                    logo: data.logo,
                    label: data.name
                }
            })
            setCustomersList((prevList) => {
                const uniqueList = [...prevList, ...newList].reduce((acc, item) => {
                    if (!acc.some(existingItem => existingItem.id === item.id)) {
                        acc.push(item);
                    }
                    return acc;
                }, []);
                return uniqueList; //Prevents duplicate additions, avoiding redundant state updates
            });
            setCustomerTotalPage(customerListResponse?.meta?.total_pages)
            dispatch(resetCustomersList())
        }
    },[customerListResponse, dispatch])

    useEffect(()=>{
        if(assignedCustomersListForMonitorsResponse != null) {
            setAssignedCustomerSearchLoading(false)
            let newList = assignedCustomersListForMonitorsResponse?.results.map((data)=>{
                return {
                    id: data.customer_id,
                    name: data.name,
                    value: data.customer_id,
                    logo: data.logo,
                    label: data.name
                }
            })
            setAssignedCustomersList((prevList) => {
                const uniqueList = [...prevList, ...newList].reduce((acc, item) => {
                    if (!acc.some(existingItem => existingItem.id === item.id)) {
                        acc.push(item);
                    }
                    return acc;
                }, []);
                return uniqueList; //Prevents duplicate additions, avoiding redundant state updates
            });
            setAssignedCustomerTotalPage(assignedCustomersListForMonitorsResponse?.meta?.total_pages)
        }
    },[assignedCustomersListForMonitorsResponse])

    useEffect(()=>{
        if(assignUnAssignResponse !== null ) {
            setIsLoading(false)
            setResponseStatus(true)
        } else {
            setIsLoading(false)
            setResponseStatus(false)
        }
    },[assignUnAssignResponse])


    return (
        <div className="add-monitor-container">
            {!responseStatus && <>
                <div className="modal-header mt-4">
                    <h2>{t("monitorPage.modifyMonitor.heading")}</h2>
                </div>
                <div className="organization-main-container mt-4">
                    <div className="orgs-tab-container d-flex rounded">
                        <p className={`rounded text-center ${activeTab === "assign" ? "active" : ""}`} onClick={()=>changeTab("assign")}>Assign</p>
                        <p className={`rounded text-center ${activeTab === "unAssign" ? "active" : ""}`} onClick={()=>changeTab("unAssign")}>Unassign</p>
                    </div>
                </div>
                <div className="add-organization-step-one mt-3">
                    <div className="input-container mb-4">                   
                            {activeTab === "assign" && <DropDown
                                options={customerList}
                                placeHolder='Please select Customer'
                                dropDownType={"modifyCustomer"}
                                onChange={(e) => handleSelectCustomer(e)}
                                isSearchable = {true}
                                isMulti
                                searchType={"server"}
                                defaultSelectedValue={selectedCustomer}
                                updateSearchValue={(data)=>{
                                    setCustomersList([])
                                    setCustomerSearchLoading(true)
                                    setCustomerSearchValue(data)
                                    setCustomerCurrentPage((prevPage) => (prevPage !== 1 ? 1 : prevPage));                                    
                                }}
                                isSearchLoading={customerSearchLoading}
                                onScrollEnd = {()=>{
                                    if(!customerPageLoading && (customerTotalPage > customerCurrentPage)) {
                                        setCustomerPageLoading(true)
                                        setCustomerCurrentPage((prevPage) => prevPage + 1)
                                    }
                                }}
                                pageLoading={customerPageLoading}
                            />}
                            {activeTab === "unAssign" && <DropDown
                                options={assignedCustomersList}
                                placeHolder='Please select Customer'
                                dropDownType={"modifyCustomer"}
                                onChange={(e) => handleSelectCustomer(e)}
                                isSearchable = {true}
                                isMulti
                                searchType={"server"}
                                defaultSelectedValue={selectedCustomer}
                                updateSearchValue={(data)=>{
                                    setAssignedCustomersList([])
                                    setAssignedCustomerSearchLoading(true)
                                    setAssignedCustomerSearch(data)
                                    setAssignedCustomerCurrentPage((prevPage) => (prevPage !== 1 ? 1 : prevPage)); 
                                }}
                                isSearchLoading={assignedCustomerSearchLoading}
                                onScrollEnd = {()=>{
                                    if(!assignedCustomerPageLoading && (assignedCustomerTotalPage > assignedCustomerCurrentPage)) {
                                        setAssignedCustomerPageLoading(true)
                                        setAssignedCustomerCurrentPage((prevPage) => prevPage + 1)
                                    }
                                }}
                                pageLoading={assignedCustomerPageLoading}
                            />}
                    </div>
                    
                </div>
                <div className="form-submit-btn-group mt-4">
                    <Button buttonText={"Cancel"} buttonType="secondary" buttonClicked={()=>{goBack()}}/>
                    {!isLoading && <Button buttonText={"Save"} buttonType="primary" buttonClicked={()=>{saveList()}} disableButton={selectedCustomer.length === 0} />}
                    {isLoading && <Button buttonText={"Loading..."} buttonType="primary" disableButton={true} />}
                </div>
            </>}
            
            {responseStatus && <>
                <div className="addOrg-success-container d-flex align-items-center flex-column">
                    {assignUnAssignResponse?.detail?.status === "success" && <>
                        <div className="mt-5">
                            <img src={successTick} alt="success" />
                        </div>
                        <h2 className="mb-4 mt-5">{assignUnAssignResponse?.detail?.description}</h2>
                    </>}
                    {assignUnAssignResponse?.status === "failed" && <div className="addOrg-success-container d-flex align-items-center flex-column">
                            <div className="mt-5">
                                <img src={failed} alt="failed" />
                            </div>
                            <h2 className="mb-4 mt-5 fs-4">{assignUnAssignResponse?.description}</h2>
                            </div>}
                    <div className="btn-container mt-5">
                        <Button buttonText={"Back to Main Page"} buttonType="primary" buttonClicked={()=>{goBack()}} />
                    </div>
                </div>
            </>}
        </div>
    );
};

export default ModifyMonitorModal;
